import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useLocalizeMessage } from 'libs.nucleus';
import { StepIndicator } from 'libs.react';
/**
 * A reusable footer component for multi-step forms or wizards
 * that shows the current step and progress indicator
 */
export const StepFooter = ({ currentStep, totalSteps, textFormat = 'Step {current} of {total}', className = '', }) => {
    const translate = useLocalizeMessage();
    return (_jsxs("div", { className: `flex justify-center items-center ${className}`, children: [_jsx("p", { className: 'px-6 text-sm', children: translate(textFormat, {
                    current: currentStep,
                    total: totalSteps,
                }) }), _jsx(StepIndicator, { currentStep: currentStep, totalSteps: totalSteps })] }));
};
